import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { LinkCSS } from '@allenai/varnish/components';
export const Link = styled(NavLink) `
    ${LinkCSS.default()}
`;
